
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.019.265a.75.75 0 011.056.094L6 5.053 9.925.36a.75.75 0 111.15.962L6.848 6.377A1.14 1.14 0 016 6.75a1.165 1.165 0 01-.78-.301.75.75 0 01-.068-.072L.925 1.321A.75.75 0 011.019.265z"}})])
          )
        }
      }
    